import { configureStore } from '@reduxjs/toolkit'
import configReducer from './slices/configSlice'
import userReducer from './slices/userSlice'
import behaviorReducer from './slices/behaviorSlice'

export const store = configureStore({
  reducer: {
    config: configReducer,
    user: userReducer,
    behavior: behaviorReducer
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch